module.exports = __webpack_public_path__ + "img/playfair-display-v22-latin-regular.16e8de2b.svg";